// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"596ab056","422":"d950ba8b","464":"a131c39e","725":"034089a9"}[chunkId] + ".chunk.js";
};